import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
          分类浏览
        </h2>
        <p className="text-sm text-foreground-500 mt-1">探索您感兴趣的漫画类型</p>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-100 transition-all duration-200 group cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-500 transition-colors duration-200">
              <i className={`${cat.icon} text-lg text-foreground-600 group-hover:text-background-50 transition-colors duration-200`}></i>
            </div>
            <span className="text-xs text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}